// 引入api请求方法

import { invoiceList, waybillInvoiceExport } from '@/api/account';

const storeModuleName = 'routeTransferModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: {
    isShow: true,
    method: 'get',
    url: `${waybillInvoiceExport}?status=INVOICED`,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '申请时间',
        prop: 'applicationTime',
        width: 90,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-applicationTime',
      },
      {
        label: '发票编号',
        prop: 'invoiceNumber',
        width: 110,
        checked: 1,
        sortable: true,
        // slotName: 'sub-domain-payAmt',
      },
      {
        label: '开票金额',
        prop: 'invoiceAmount',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-invoiceAmount',
      },
      {
        label: '税额',
        prop: 'payAmount',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payAmount',
      },
      {
        label: '开票方',
        prop: 'channelInfoName',
        width: 85,
        checked: 1,
        sortable: true,
      },
      {
        label: '关联运单',
        prop: 'waybillNum',
        width: 85,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillNum',
      },
      {
        label: '发票抬头',
        prop: 'lookUp',
        width: 135,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-lookUp',
      },
      {
        label: '邮寄信息',
        prop: 'recipient',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-recipient',
      },
      {
        label: '操作',
        prop: '',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
        isHide: true,
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
    });
    params.status = 'INVOICED';
    const { data } = await invoiceList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign(
        {},
        { list: data.records },
        { total: data.total },
        { tableHeadList: context.state.listData.tableHeadList },
      ),
    });
    return data.records;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
